import baseClasses from '@components/Themes/layout.module.scss'
import React, { FunctionComponent } from 'react'

import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Toolbar from '@mui/material/Toolbar'
import { loadToppagesjoinus, searchToppagesjoinus } from '@store/actions/toppagesjoinusActions'
import { IState } from '@store/reducers/index'
import TopPageCarouselmodulescss from 'dist/css/TopPageCarousel.module.scss'
import 'react-multi-carousel/lib/styles.css'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const AptugoComponent: FunctionComponent<any> = (props) => {
  const theme = { ...baseClasses, ...TopPageCarouselmodulescss }
  const sectHeroImage = useSelector((state: IState) => state.toppagesjoinus).toppagesjoinus
  const toppagesjoinusData = useSelector((state: IState) => state.toppagesjoinus)
  const [isOpen, setisOpen] = React.useState<any>(false)
  const [openMenu, setopenMenu] = React.useState<any>(false)
  const menuRef = React.useRef(null)
  const dispatch = useDispatch()
  const [LoadfromDatabaseloadoptions, setLoadfromDatabaseloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseload = (options) => {
    dispatch(options.searchString ? searchToppagesjoinus(options) : loadToppagesjoinus(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseload({
      ...LoadfromDatabaseloadoptions,
    })
  }, [LoadfromDatabaseloadoptions])

  React.useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setopenMenu(false)
    }
  }

  // Theme selection

  return (
    <React.Fragment>
      <div data-title="div Container Carousel" className={theme.containerCarousel}>
        <Container className={theme.containerTopPage} maxWidth={false}>
          <AppBar elevation={0} color="transparent" position="static" title="">
            <Toolbar className={theme.navbar}>
              <Container className={theme.containerInNavBar} maxWidth="xl">
                <div data-title="div .mobile" className={theme.mobile}>
                  <div data-title="div menu" className={theme.flexIconMenu} style={{ cursor: 'pointer' }}>
                    <div data-title="anvorguesita" className={theme.anvorguesita} ref={menuRef}>
                      <div className={theme.burgermenu}>
                        <input className={theme.menucheck} type="checkbox" name="menucheck" value="" id="menucheck" checked={openMenu} />
                        <label className={theme.menuopen} htmlFor="menucheck" onClick={(e) => setopenMenu(!openMenu)}>
                          <span className={theme.burger1}></span>
                          <span className={theme.burger2}></span>
                          <span className={theme.burger3}></span>
                        </label>
                      </div>

                      {openMenu && (
                        <React.Fragment>
                          <div data-title="Desplegable" className={openMenu ? theme.menuActive : theme.menuDesplegableInactivo}>
                            <div data-title="Links" className={theme.linksNoLoginMenu}>
                              <div data-title="linkItem" className={theme.linkItem}>
                                <NavLink to="/">
                                  <Button color="primary" className={theme.buttonNavHomeNoLogin}>
                                    REAL TRAVEL
                                  </Button>
                                </NavLink>

                                <NavLink to="/JoinUs#contactUs">
                                  <Button color="primary" className={theme.buttonNavHomeNoLogin}>
                                    Sé parte
                                  </Button>
                                </NavLink>

                                <NavLink to="/AboutUs">
                                  <Button color="primary" className={theme.buttonNavHomeNoLogin}>
                                    Quienes somos
                                  </Button>
                                </NavLink>

                                <NavLink to="/Press">
                                  <Button color="primary" className={theme.buttonNavHomeNoLogin}>
                                    Prensa
                                  </Button>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </Container>
            </Toolbar>
          </AppBar>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AptugoComponent
